<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<style lang="scss">
#app {
  height: 100vh;
}
</style>

<script>
const dashboard = "dashboard";
export default {
  mounted() {
    if (localStorage.getItem("id_token") == null) {
      // this.$router.push("/login");
    }
  },
  computed: {
    layout() {
      // if(localStorage.getItem('id_token') != null){
      //   return dashboard + "_layout";
      // }else{
      //   return "login_layout";
      // }
      return (this.$route.meta.layout || dashboard) + "_layout";
    }
  }
};
</script>